import { Editor, Transforms, Node, Path } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

import elementTypes from '../../elements/types';
import HelptapEditor from '../';
import * as baseNodeUtilities from './base-node';

export function getDefaultOptions() {

  const options = baseNodeUtilities.getDefaultOptions();

  return options;

}

export function buildNode(options = {}) {

  const node = {
    ...getDefaultOptions(),
    ...options,
    type: elementTypes.TABLE_OF_CONTENTS,
    properties: {
      contents: []
    }
  };

  return node;

}

export function insert(editor, path) {

  const node = buildNode();

  node.properties.contents = generateContents(editor, path);

  HelptapEditor.insertNode(editor, node, path);

}

export function toggle(editor, nodeOptions, editorOptions) {

  const _nodeOptions = buildNode();

  _nodeOptions.properties.contents = generateContents(editor, Path.parent(editorOptions.at.path));

  HelptapEditor.setNodeOptions(editor, _nodeOptions, editorOptions);

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = HelptapEditor.cloneNode(node);

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}

export function generateContents(editor, startPath) {

  const contents = [];

  let nextPath = startPath;
  let nextNode = null;

  let nextEntry = Editor.next(editor, { at: nextPath });

  while (nextEntry !== void 0) {

    [nextNode, nextPath] = nextEntry;

    const nodeType = nextNode.type;

    if (serializer.allTypes.headingElements.indexOf(nodeType) !== -1) {

      let label = Node.string(nextNode).trim();

      if (label === '') {
        label = 'Untitled';
      }

      contents.push({
        type: nodeType,
        label,
        path: nextPath
      });
    } else if (nodeType === elementTypes.TABLE_OF_CONTENTS) {
      break;
    }

    nextEntry = Editor.next(editor, { at: nextPath });

  }

  return contents;

}

export function updateContents(editor, tableOfContentsNode, tableOfContentsPath) {

  const contents = generateContents(editor, tableOfContentsPath);

  Transforms.setNodes(editor, {
    properties: {
      ...tableOfContentsNode.properties,
      contents
    }
  }, { at: tableOfContentsPath });

}

export function update(editor, path) {

  let nextEntry = Editor.previous(editor, { at: path });

  while (nextEntry !== void 0) {

    let [nextNode, nextPath] = nextEntry;

    if (nextNode.type === elementTypes.TABLE_OF_CONTENTS) {
      updateContents(editor, nextNode, nextPath);
    }

    nextEntry = Editor.previous(editor, { at: nextPath });

  }

}

export function updateAll(editor) {

  update(editor, [editor.children.length - 1]);

}